import { PlannerBase } from 'mixs/orders/planner_base';

class OrdersTodayCalendar extends PlannerBase {
  // // ordersPhase: any = {}
  // init(){
  //   super.init();
  //   console.log(this.opts)
  // //   for(let i=0; i<this.opts.phases.length; i++){
  // //     let ordersPhase = this.opts.phases[i];
  // //     if(ordersPhase.id == this.opts.phaseId){
  // //       this.ordersPhase = ordersPhase;
  // //       break;
  // //     }
  // //   }
  // //   console.log(this.ordersPhase);
  // }

}

riot.mixin('orders.today-calendar', OrdersTodayCalendar as riot.TagMixin)
